import { render, staticRenderFns } from "./DetalleModificacionDatosPersonales.vue?vue&type=template&id=1df5dedb"
import script from "./DetalleModificacionDatosPersonales.vue?vue&type=script&lang=js"
export * from "./DetalleModificacionDatosPersonales.vue?vue&type=script&lang=js"
import style0 from "./DetalleModificacionDatosPersonales.vue?vue&type=style&index=0&id=1df5dedb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports